import { createSelector } from 'reselect'

import { isAvailableFeatureSelector } from 'features/billing'

import { STEPS } from './slice'

const baseSelector = ({ hostReschedule }) => hostReschedule

export const isHostRescheduleEnabledSelector = (state) => isAvailableFeatureSelector(
  state, { featureKey: 'host_reschedule_request' }
)

export const isShareOrReschedulePopupOpenSelector = createSelector(baseSelector,
  ({ step }) => step === STEPS.shareOrReschedule)

export const isHostPickerPopupOpenSelector = createSelector(baseSelector,
  ({ step }) => step === STEPS.hostPicker)
